// import $ from "jquery";
import {Loader} from "@googlemaps/js-api-loader"

const mapStyle = require("./goole-map-style.js");

$(function () {
    const markers = $('span.gmap-marker');
    let map, location, list_location = [];
    let el = $("#g-map").get(0);

    // Check if map container exists
    if (!el) {
        console.error('Map container #g-map not found!');
        return;
    }


    // Collect markers first
    const getLocation = (el) => {
        return {
            title: el.data('title'),
            lat: parseFloat(el.data('latlng').split(',')[0]),
            lng: parseFloat(el.data('latlng').split(',')[1]),
            icon: el.data('icon')
        };
    }

    if (markers.length) {
        markers.each(function () {
            location = getLocation($(this))
            list_location.push(location)
        });
    }


    const loader = new Loader({
        apiKey: "AIzaSyAVjxnANd6GRHzpoC2ZL7ps91sl_q6JIeA",
        version: "weekly",
        libraries: ["marker"],
        language: "ja",
        region: "JP"
    });

    loader.load().then(async () => {
        try {
            const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");
            
            // Create map with Map ID for AdvancedMarkerElement
            const map = new google.maps.Map(el, {
                mapId: "3fae42e16ac2d38", // Required for AdvancedMarkerElement
                zoom: 10, // Default zoom level
                center: { lat: 35.6762, lng: 139.6503 } // Default center (Tokyo)
            });
            
            setMarkers(map, AdvancedMarkerElement)
        } catch (error) {
            console.error('Error initializing map:', error);
        }
    }).catch(error => {
        console.error('Error loading Google Maps API:', error);
    });

    function setMarkers(map, AdvancedMarkerElement) {
        let bounds = new google.maps.LatLngBounds();
        const infowindow = new google.maps.InfoWindow();
        
        if (list_location.length === 0) {
            return;
        }
        
        for (let i = 0; i < list_location.length; i++) {
            let area = list_location[i];
            
            // Create custom marker element for the icon
            const markerElement = document.createElement('img');
            markerElement.src = area.icon;
            markerElement.style.width = '20px';
            markerElement.style.height = '28px';

            let marker = new AdvancedMarkerElement({
                position: { lat: area.lat, lng: area.lng },
                map: map,
                content: markerElement,
                title: area.title
            });

            bounds.extend(marker.position);
            
            marker.addListener('gmp-click', () => {
                infowindow.setContent(
                  `<div id="gmap-window"><h1>${area.title}</h1></div>`
                );
                infowindow.open(map, marker);
            });
        }
        
        // Only fit bounds if we have markers
        if (list_location.length > 0) {
            map.fitBounds(bounds);
        }
    }
})

